import { Input as AntdInput } from 'antd';

import { styled } from 'utils/styledComponent';

export const StyledTextArea = styled(AntdInput.TextArea)`
  border-radius: 8px;
`;
